export function isMobileDevice(): boolean {
  try {
    const ua = (navigator && navigator.userAgent) ? navigator.userAgent.toLowerCase() : ''
    const isTouch = (navigator as any)?.maxTouchPoints > 0 || /touch/.test(ua)
    const isSmallViewport = typeof window !== 'undefined' ? Math.min(window.innerWidth, window.innerHeight) <= 900 : false
    const hasMobileUA = /(iphone|ipad|ipod|android|mobile)/i.test(ua)
    return !!(hasMobileUA || (isTouch && isSmallViewport))
  } catch {
    return false
  }
}

